'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byAbbr = exports.byName = exports.data = undefined;

var _data = require('./data');

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byName = Object.create(null);
var byAbbr = Object.create(null);

for (var i = 0, il = _data2.default.length; i < il; i++) {
  var item = _data2.default[i];
  var name = item.name,
      abbr = item.abbr;

  byName[name] = item;
  byAbbr[abbr] = item;
}

exports.data = _data2.default;
exports.byName = byName;
exports.byAbbr = byAbbr;
exports.default = {
  data: _data2.default,
  byName: byName,
  byAbbr: byAbbr
};